import React from "react";
import whatsappIcon from "../../assets/Icons/icons8-whatsapp-48.png";
import instagramIcon from "../../assets/Icons/icons8-instagram-48.png";
import facebookIcon from "../../assets/Icons/icons8-facebook-48.png";
import youtubeIcon from "../../assets/Icons/icons8-youtube-48.png";

export default function SocialFloatingIcons() {
  return (
    <div id="socialFloatingIcons" className="fixed top-32 right-3 sm:top-36 sm:right-4 flex flex-col space-y-3 sm:space-y-4 z-40 animate-slide-in">
      {/* WhatsApp */}
      <a
        href="https://wa.me/919825772794"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-500 w-9 h-9 sm:w-10 sm:h-10 rounded-full shadow-glow hover:bg-green-600 transition-all duration-300 ease-in-out flex items-center justify-center"
        aria-label="Chat with us on WhatsApp"
        title="Chat with us on WhatsApp"
      >
        <img src={whatsappIcon} className="w-5 h-5 sm:w-6 sm:h-6 object-contain" alt="WhatsApp" />
      </a>

      {/* Instagram */}
      <a
        href="https://www.instagram.com/m.s.education"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-pink-500 w-9 h-9 sm:w-10 sm:h-10 rounded-full shadow-glow hover:bg-pink-600 transition-all duration-300 ease-in-out flex items-center justify-center"
        aria-label="Follow us on Instagram"
        title="Follow us on Instagram"
      >
        <img src={instagramIcon} className="w-5 h-5 sm:w-6 sm:h-6 object-contain" alt="Instagram" />
      </a>

      {/* Facebook */}
      <a
        href="https://www.facebook.com/mseducationconsultancy/"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-blue-600 w-9 h-9 sm:w-10 sm:h-10 rounded-full shadow-glow hover:bg-blue-700 transition-all duration-300 ease-in-out flex items-center justify-center"
        aria-label="Visit our Facebook"
        title="Visit our Facebook"
      >
        <img src={facebookIcon} className="w-5 h-5 sm:w-6 sm:h-6 object-contain" alt="Facebook" />
      </a>

      {/* YouTube */}
      <a
        href="https://www.youtube.com/@m.s.educationconsultant"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-red-200 w-9 h-9 sm:w-10 sm:h-10 rounded-full shadow-glow hover:bg-red-700 transition-all duration-300 ease-in-out flex items-center justify-center"
        aria-label="Visit our YouTube"
        title="Visit our YouTube"
      >
        <img src={youtubeIcon} className="w-5 h-5 sm:w-6 sm:h-6 object-contain" alt="YouTube" />
      </a>
    </div>
  );
}
